import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  fetchCompany,
  createTemplate,
  fetchTemplateCategories,
  fetchVideoTemplates,
  createTestEmail
} from "../actions/index";
import { Link } from "react-router-dom";
import TemplatesForm from "./TemplatesForm";
import { CSSTransitionGroup } from 'react-transition-group';
import { toastr } from "react-redux-toastr";
import * as Constants from '../constants';

class TemplatesNew extends Component {
  static propTypes = {
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    createTemplate: PropTypes.func.isRequired,
    fetchTemplateCategories: PropTypes.func.isRequired,
    fetchVideoTemplates: PropTypes.func.isRequired,
    createTestEmail: PropTypes.func.isRequired,
    categories: PropTypes.func.isRequired,
    videoTemplates: PropTypes.object
  };

  constructor(props) {
    super(props);
    this.state = {
      site_domain: null
    };
  }

  componentDidMount() {
    this.props.fetchTemplateCategories();
    this.props.fetchVideoTemplates("?sort=name&direction=asc");
    this.props.fetchCompany().then(response => {
      if (response.payload.status == 200) {
        this.setState({ site_domain: response.payload.data.data.site_domain });
      }
    });
  }

  onSubmit(state) {
    this.props
      .createTemplate(state)
      .then(response => {
        if (response.payload !== undefined) {
          toastr.success("Email Template created!");
          this.props.history.push(`/templates?${Constants.DEFAULT_PAGINATION}`);
        }
      });
  }

  sendTestEmail(state) {
    this.props
      .createTestEmail(state)
      .then(response => {
        if (response.payload.status == 200) {
          toastr.success("Test Email Sent!");
        }
      });
  }

  videoMail() {
    let query = new URLSearchParams(this.props.location.search);
    let s3_url = query.get('s3_url');

    if (s3_url) {
      let arr = s3_url.split("/");
      let id = arr[arr.length - 1].split('.').slice(-2)[0] ;
      let urlArr = s3_url.split(".");
      urlArr.pop();
      let url = urlArr.join('.');
      let siteDomain = this.state.site_domain;
      return "<a href='http://" + siteDomain + "/vid/" + id +"?login={{LEAD_UUID}}'><img src='" + url + ".gif'></a>";
    } else {
      return "";
    }
  }

  defaultBody() {
    return "<p>Hi&nbsp;&nbsp;{{FIRST_NAME}},</p> <p>&nbsp;</p>" + this.videoMail() + " <p>&nbsp;{{AGENT_EMAIL_SIGNATURE}}</p>";
  }

  render() {
    const { categories, videoTemplates } = this.props;


    if (!categories.data || !videoTemplates.data || !this.state.site_domain ) {
      return (
        <div className="vertical-center">
          <CSSTransitionGroup
            transitionName="spinner"
            transitionAppear={true}
            transitionAppearTimeout={500}
          >
            <i className="fa fa-refresh fa-4x fa-spin" />
          </CSSTransitionGroup>
        </div>
      );
    }
    let body = this.defaultBody();
    return (
      <div>
        <h1>Add New Template</h1>
        <TemplatesForm
          handleSubmit={this.onSubmit.bind(this)}
          handleSendTestEmail={this.sendTestEmail.bind(this)}
          categories={categories.data}
          videoTemplates={videoTemplates.data}
          match={this.props.match}
          subject=""
          body={body}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return { categories: state.templateCategories.all, videoTemplates: state.videoTemplates.all };
}

export default connect(
  mapStateToProps,
  { fetchCompany, createTemplate, fetchTemplateCategories, createTestEmail, fetchVideoTemplates }
)(TemplatesNew);
